class ProductQuickBuy extends window.BAO.CustomElement() {
  static get requiredElements() {
    return ["trigger"];
  }

  static get requiredAttributes() {
    return ["data-handle"];
  }

  setupListeners() {
    super.setupListeners();

    this.handleTrigger = this.handleTrigger.bind(this);

    this.els.trigger.elements.forEach((triggerEl) => {
      this.listeners.add(triggerEl, "click", this.handleTrigger);
    });
  }

  async handleTrigger(e) {
    e.preventDefault();

    if (!this.externalEls?.container?.exists) {
      console.error("product-quick-buy: missing drawer container");
      return;
    }

    const url = `/products/${this.dataset.handle}?section_id=quick-buy`;

    try {
      const html = await window.BAO.sectionRenderer.fetchSingle(
        "quick-buy",
        url,
      );

      this.externalEls.container.element.innerHTML = html;

      if (window.drawers) {
        window.drawers.activeDrawerKey = "product-quick-buy";
      }
    } catch (error) {
      console.error("product-quick-buy: fetch failed", error);
    }
  }
}

if (!customElements.get("product-quick-buy")) {
  customElements.define("product-quick-buy", ProductQuickBuy);
}
